<template>
  <div class="gst-pop-outer">
    <div class="gst-popup-header">
      <div class="cart-title-text">UPGRADE NOW</div>
      <v-icon
        class="mdi-close-right"
        @click="onClose({ status: false })"
        >mdi-close</v-icon
      >
    </div>
    <div class="gst-popup">
      <div class="modal-top-success-text">
        <div class="span-bold mb-5">
          You need to have access to MASTER PYQs to continue. Here's what you get
        </div>
      </div>
      
      <div class="price-row-pop">
        <ul class="benefits-list">
          <li>Access to all Paid Previous Year's Tests</li>
          <li>Practice unlimited questions per day</li>
          <li>Reports of Practice Sessions</li>
          <li>Practice Similar Questions from Past Test</li>
          <li>Make Your Own tests from PY Questions</li>
          <li>Retry questions you have already attempted</li>
        </ul>
      </div>
      
      <div class="cart-btn new-cr-cart mt-10">
        <v-btn
          @click="onClose({ status: false })"
          class="right-btn cust-btn white-clrr"
          color="grey"
          text
        >
          May be Later
        </v-btn>
        <v-btn
          @click="handleProceed"
          class="right-btn cust-btn blue-clrr"
          color="primary"
          :loading="loading"
        >
          Proceed
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'UpgradeConfirmationModal',
  props: {
    onClose: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState('userStore', ['user'])
  },
  methods: {
    ...mapActions({
      getPriceDetails: 'userStore/getPriceDetails',
      createPackageOrder: 'userStore/createPackageOrder'
    }),
    
    handleMaybeLater() {
      this.onClose({ status: false });
    },
    
    handleMaybeLater() {
      this.onClose({ status: false });
    },
    
    async handleProceed() {
      this.loading = true;
      
      try {
        const productId = this.getMasterPyqProductId();
        console.log('Product ID:', productId);
        const reqData = { product_ids: [productId] };
        
        const response = await this.getPriceDetails(reqData);
        this.showOrderConfirmation(response);
      } catch (error) {
        this.$toasted.error('Failed to fetch price details');
      } finally {
        this.loading = false;
      }
    },
    
    getMasterPyqProductId() {
      const constants = require('@/utils/constants').default;
      
      if (this.user && this.user.batch_name === '2026') {
        if (this.user.center_name === 'JEE' || this.user.center_name === 'Engineering') {
          return constants.MODULES.MASTERPYQJEE26;
        } else {
          return constants.MODULES.MASTERPYQNEET26;
        }
      } else if (this.user && this.user.batch_name === '2027') {
        if (this.user.center_name === 'JEE' || this.user.center_name === 'Engineering') {
          return constants.MODULES.MASTERPYQJEE27;
        } else {
          return constants.MODULES.MASTERPYQNEET27;
        }
      } else if (this.user && this.user.batch_name === '2028') {
        if (this.user.center_name === 'JEE' || this.user.center_name === 'Engineering') {
          return constants.MODULES.MASTERPYQJEE28;
        } else {
          return constants.MODULES.MASTERPYQNEET28;
        }
      }
    },
    
    showOrderConfirmation(priceDetails) {
      const productId = this.getMasterPyqProductId();
      
      // Close current modal and open payment modal
      this.onClose({ 
        status: false,
        openPaymentModal: true,
        paymentData: {
          prodObj: priceDetails.prodObj || [{
            id: productId,
            name: 'Master Previous Years Questions (PYQs)',
            group_name: 'MASTERPYQ',
            price: priceDetails.total_product_amount || 0
          }],
          priceDetails: priceDetails
        }
      });
    }
  }
};
</script>

<style scoped>
.benefits-list {
  list-style-type: disc;
  padding-left: 20px;
  margin: 0;
}

.benefits-list li {
  margin-bottom: 8px;
  font-size: 14px;
  color: #555;
}

.cart-btn {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.cart-btn .right-btn {
  flex: 1;
}
</style>